import {
  Field,
  ImageField,
  LinkField,
  RichTextField,
  TextField,
} from '@sitecore-jss/sitecore-jss-nextjs';

import { ButtonVariantType } from '@gn-audio/jss-components/components';

export type FirstButtonSettings = {
  firstButtonLink: LinkField;
  firstButtonText: TextField;
  firstButtonVariant: Field<ButtonVariantType>;
};

export type SecondButtonSettings = {
  secondButtonLink: LinkField;
  secondButtonText: TextField;
  secondButtonVariant: Field<ButtonVariantType>;
};

export type DualColumnPromoItem = {
  id: string;
  image: ImageField;
  headline: RichTextField;
  description: RichTextField;
} & FirstButtonSettings &
  SecondButtonSettings;
